import { createReducer, on } from '@ngrx/store';

import { INITIAL_CURRENCY_STATE } from '../../operator-settings.state';
import { OperatorSettingsCurrencyActions } from '../currency.actions';

export const operatorSettingsCurrencyReducer = createReducer(
  INITIAL_CURRENCY_STATE,

  on(OperatorSettingsCurrencyActions.loadCurrencies, (state) => ({
    ...state,
    loadState: 'loading' as const,
    error: null,
  })),

  on(
    OperatorSettingsCurrencyActions.loadCurrenciesSuccess,
    (state, { currencies }) => ({
      ...state,
      currencies,
      loadState: 'loaded' as const,
      error: null,
    }),
  ),

  on(
    OperatorSettingsCurrencyActions.loadCurrenciesFailure,
    (state, { error }) => ({
      ...state,
      loadState: 'error' as const,
      error,
    }),
  ),

  on(
    OperatorSettingsCurrencyActions.updateCurrencySuccess,
    (state, { currencyShortCode, fx, crRate, symbol }) => ({
      ...state,
      currencies: state.currencies.map((currency) =>
        currency.currencyShortCode === currencyShortCode
          ? { ...currency, fx, crRate, symbol }
          : currency,
      ),
    }),
  ),

  on(
    OperatorSettingsCurrencyActions.updateCurrencyFailure,
    (state, { error }) => ({
      ...state,
      error,
    }),
  ),
);
